import React from "react"
import CHECK_GREEN from "../../../assets/icons/updated-check-green.svg";
import clxs from "./guest-consent-success.module.css";

function GuestConsentSuccess() {

  return (
    <div className={clxs.container}>
      <img
        src={CHECK_GREEN}
        alt="Points Success"
        className={clxs.checkGreen}
      />

      <div className={clxs.title}>Thank you!</div>
      <div className={clxs.content}>Your consent form has been successfully submitted.
        <br />
        We appreciate your cooperation.
      </div>
    </div >
  )
}

export default GuestConsentSuccess
